import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { StoreProvider } from "@/context/Store";
import Header from "@/components/site/Header";
import Footer, { WhatsAppFab } from "@/components/site/Footer";
import CartDrawer from "@/components/site/CartDrawer";
import Home from "@/pages/Home";
import { CategoryPage, SearchPage } from "@/pages/Catalog";
import ProductPage from "@/pages/ProductPage";
import CheckoutPage from "@/pages/CheckoutPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import { IdeaPage, AboutPage, FaqPage } from "@/pages/InfoPages";
import AdminPage from "@/pages/admin/AdminPage";
import TrackPage from "@/pages/TrackPage";
import { LegalPage, CookieBanner, NotFound } from "@/pages/LegalPages";

function SiteLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <WhatsAppFab />
      <CartDrawer />
      <CookieBanner />
    </div>
  );
}

export default function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/c/:cat" element={<CategoryPage />} />
            <Route path="/c/:cat/:sub" element={<CategoryPage />} />
            <Route path="/p/:slug" element={<ProductPage />} />
            <Route path="/pesquisa" element={<SearchPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/pagamento/sucesso" element={<PaymentSuccess />} />
            <Route path="/pagamento/cancelado" element={<PaymentCancel />} />
            <Route path="/ideia" element={<IdeaPage />} />
            <Route path="/sobre" element={<AboutPage />} />
            <Route path="/perguntas" element={<FaqPage />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
            <Route path="/acompanhar" element={<TrackPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </StoreProvider>
  );
}
